import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { platformApi } from '@/lib/platform-client'

// ── Thông báo Lark cho giao dịch của tổ chức (Platform → Thông báo Lark) ──
// Backend: platform/platform-billing-lark-routes.ts. URL bot / khoá ký không bao giờ được trả lại nguyên văn.
export type BillingLarkEventKey = 'org_signup' | 'plan_paid' | 'addon_paid' | 'credit_topup'

export interface BillingLarkEvent { key: BillingLarkEventKey; label: string; description: string; enabled: boolean }

export interface BillingLarkSettings {
  /** Đang thực sự báo vào Lark (đã bật + có URL hợp lệ). */
  active: boolean
  source: 'settings' | 'env' | 'none'
  enabled: boolean
  hasUrl: boolean
  urlMasked: string | null
  hasSecret: boolean
  envConfigured: boolean
  updatedAt: string | null
  events: BillingLarkEvent[]
}

export interface BillingLarkPatch {
  enabled?: boolean; webhookUrl?: string; secret?: string; clearSecret?: boolean; clear?: boolean
  events?: Partial<Record<BillingLarkEventKey, boolean>>
}

const KEY = ['platform', 'billing-lark'] as const
const URL_ = '/platform/settings/billing-lark'

export function useBillingLark() {
  return useQuery<BillingLarkSettings>({
    queryKey: KEY,
    staleTime: 0,
    queryFn: async () => (await platformApi.get<BillingLarkSettings>(URL_)).data,
  })
}

export function useSaveBillingLark() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (patch: BillingLarkPatch) => (await platformApi.put<BillingLarkSettings>(URL_, patch)).data,
    onSuccess: (data) => qc.setQueryData(KEY, data),
  })
}

export function useTestBillingLark() {
  return useMutation({
    mutationFn: async (body: { event?: BillingLarkEventKey; webhookUrl?: string; secret?: string }) =>
      (await platformApi.post<{ ok: boolean; error?: string }>(`${URL_}/test`, body)).data,
  })
}
